(() => {
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const cartContent = document.querySelector('[data-cart-content]');
  const cartPanel = document.querySelector('[data-cart-panel]');
  const shopRoot = window.Shopify?.routes?.root || '/';
  const cartEndpoint = `${shopRoot}cart.js`;
  const cartChangeEndpoint = `${shopRoot}cart/change.js`;
  const freeShippingThreshold = Number(drawer?.dataset.cartFreeShippingThreshold || 0);
  let drawerTrigger = null;

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      body.classList.toggle('menu-open', open);
    });
  }

  const submenuToggles = [...document.querySelectorAll('[data-submenu-toggle]')];
  const closeSubmenus = (except = null) => {
    submenuToggles.forEach((toggle) => {
      const item = toggle.closest('.nav-item');
      if (!item || item === except) return;
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  };

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const item = toggle.closest('.nav-item');
      if (!item) return;
      const open = !item.classList.contains('is-open');
      closeSubmenus(item);
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nav-item')) closeSubmenus();
  });

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
      style: 'currency',
      currency
    }).format(cents / 100);
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const renderCart = (cart) => {
    if (!cartContent) return;
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
    });
    if (!cart.item_count) {
      cartContent.innerHTML = `
        <div class="empty-state">
          <p>O teu carrinho está vazio.</p>
          <a class="button button--gold" href="/collections/all">EXPLORAR PRODUTOS →</a>
        </div>`;
      return;
    }
    const shippingRemaining = Math.max(0, freeShippingThreshold - cart.total_price);
    const shippingProgress = freeShippingThreshold > 0
      ? Math.min(100, Math.round((cart.total_price / freeShippingThreshold) * 100))
      : 100;
    const shippingMessage = freeShippingThreshold <= 0
      ? 'Envio calculado no checkout.'
      : shippingRemaining > 0
        ? `Faltam <strong>${money(shippingRemaining)}</strong> para portes grátis.`
        : '<strong>PORTES GRÁTIS DESBLOQUEADOS</strong>';
    const shipping = `
      <div class="drawer-shipping" role="status">
        <p>${shippingMessage}</p>
        <div class="drawer-shipping__track" role="progressbar" aria-label="Progresso para portes grátis" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${shippingProgress}">
          <span style="width:${shippingProgress}%"></span>
        </div>
      </div>`;
    const lines = cart.items.map((item) => `
      <article class="drawer-line">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" width="90" height="110" loading="lazy">` : '<div></div>'}
        <div>
          <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <div class="drawer-line__footer">
            <div class="drawer-quantity" aria-label="Quantidade">
              <button type="button" aria-label="Diminuir quantidade" data-drawer-cart-change data-line-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
              <span>${item.quantity}</span>
              <button type="button" aria-label="Aumentar quantidade" data-drawer-cart-change data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}">+</button>
            </div>
            <strong>${money(item.final_line_price)}</strong>
          </div>
          <button class="drawer-remove" type="button" data-drawer-cart-change data-line-key="${escapeHtml(item.key)}" data-quantity="0">REMOVER</button>
        </div>
      </article>`).join('');
    cartContent.innerHTML = `
      ${shipping}
      <div>${lines}</div>
      <div class="drawer-summary">
        ${cart.total_discount > 0 ? `<p><span>DESCONTOS</span><strong>−${money(cart.total_discount)}</strong></p>` : ''}
        <p><span>SUBTOTAL</span><strong>${money(cart.total_price)}</strong></p>
        <a class="button button--outline" href="${shopRoot}cart">VER CARRINHO</a>
        <a class="button button--gold" href="${shopRoot}checkout">CHECKOUT SEGURO →</a>
        <p class="drawer-trust">✓ Pagamento protegido pela Shopify · Envio acompanhado</p>
      </div>`;
  };

  const fetchCart = async () => {
    const response = await fetch(cartEndpoint, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart_failed');
    return response.json();
  };

  const openCart = async (event) => {
    if (!drawer) return;
    drawerTrigger = event?.currentTarget || document.activeElement;
    drawer.hidden = false;
    body.classList.add('drawer-open');
    cartPanel?.focus();
    try {
      renderCart(await fetchCart());
    } catch {
      if (cartContent) cartContent.innerHTML = '<p>Não foi possível carregar o carrinho. <a href="/cart">Abrir carrinho</a></p>';
    }
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.hidden = true;
    body.classList.remove('drawer-open');
    drawerTrigger?.focus?.();
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  cartContent?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-drawer-cart-change]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(cartChangeEndpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: button.dataset.lineKey,
          quantity: Number(button.dataset.quantity)
        })
      });
      if (!response.ok) throw new Error('cart_change_failed');
      renderCart(await response.json());
    } catch {
      button.disabled = false;
    }
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('[data-cart-quantity]');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.stepUp();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCart();
      closeSubmenus();
      if (mobileMenu?.classList.contains('is-open')) {
        mobileMenu.classList.remove('is-open');
        menuButton?.setAttribute('aria-expanded', 'false');
        body.classList.remove('menu-open');
      }
    }
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      document.querySelector('#HeaderSearch')?.focus();
    }
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const oldText = button?.textContent;
      if (button) {
        button.disabled = true;
        button.textContent = 'A ADICIONAR…';
      }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('add_failed');
        await openCart();
      } catch {
        form.submit();
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = oldText;
        }
      }
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-breaks-catalog]').forEach((catalog) => {
    const filters = [...catalog.querySelectorAll('[data-breaks-filter]')];
    const languageFilters = [...catalog.querySelectorAll('[data-breaks-language-filter]')];
    const products = [...catalog.querySelectorAll('[data-breaks-tags]')];
    const count = catalog.querySelector('[data-breaks-count]');
    const empty = catalog.querySelector('[data-breaks-empty]');
    const shortcuts = [...document.querySelectorAll('[data-breaks-shortcut]')];
    let selectedTcg = 'all';
    let selectedLanguage = 'all';

    const getAllowedLanguages = () => {
      if (selectedTcg === 'all') {
        return languageFilters
          .map((button) => button.dataset.breaksLanguageFilter)
          .filter((value) => value && value !== 'all');
      }
      const selectedButton = filters.find((button) => button.dataset.breaksFilter === selectedTcg);
      return (selectedButton?.dataset.breaksLanguages || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
    };

    const updateActiveButtons = (buttons, selected, dataKey) => {
      buttons.forEach((button) => {
        const active = button.dataset[dataKey] === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    const applyBreaksFilters = () => {
      let visibleCount = 0;
      const knownLanguages = languageFilters
        .map((button) => button.dataset.breaksLanguageFilter)
        .filter((value) => value && value !== 'all');

      products.forEach((product) => {
        const tags = (product.dataset.breaksTags || '').split(/\s+/);
        const productLanguage = knownLanguages.find((language) => tags.includes(language));
        const productTcgButton = filters.find((button) => {
          const tcg = button.dataset.breaksFilter;
          return tcg && tcg !== 'all' && tcg !== 'outros-tcgs' && tags.includes(tcg);
        });
        const productAllowedLanguages = (productTcgButton?.dataset.breaksLanguages || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
        const matchesSupportedLanguage = !productTcgButton
          || (productLanguage && productAllowedLanguages.includes(productLanguage));
        const matchesTcg = selectedTcg === 'all' || tags.includes(selectedTcg);
        const matchesLanguage = selectedLanguage === 'all' || tags.includes(selectedLanguage);
        const visible = matchesSupportedLanguage && matchesTcg && matchesLanguage;
        product.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (count) count.textContent = String(visibleCount);
      if (empty) empty.hidden = visibleCount !== 0;
    };

    const selectTcg = (value) => {
      selectedTcg = filters.some((button) => button.dataset.breaksFilter === value) ? value : 'all';
      const allowedLanguages = getAllowedLanguages();
      languageFilters.forEach((button) => {
        const language = button.dataset.breaksLanguageFilter;
        button.hidden = selectedTcg !== 'all' && language !== 'all' && !allowedLanguages.includes(language);
      });
      if (selectedLanguage !== 'all' && !allowedLanguages.includes(selectedLanguage)) {
        selectedLanguage = 'all';
      }
      updateActiveButtons(filters, selectedTcg, 'breaksFilter');
      updateActiveButtons(languageFilters, selectedLanguage, 'breaksLanguageFilter');
      applyBreaksFilters();
    };

    const selectLanguage = (value) => {
      const allowedLanguages = getAllowedLanguages();
      const languageExists = languageFilters.some((button) => button.dataset.breaksLanguageFilter === value);
      const languageAllowed = selectedTcg === 'all' || value === 'all' || allowedLanguages.includes(value);
      selectedLanguage = languageExists && languageAllowed ? value : 'all';
      updateActiveButtons(languageFilters, selectedLanguage, 'breaksLanguageFilter');
      applyBreaksFilters();
    };

    filters.forEach((filterButton) => {
      filterButton.addEventListener('click', () => {
        selectTcg(filterButton.dataset.breaksFilter);
      });
    });

    languageFilters.forEach((filterButton) => {
      filterButton.addEventListener('click', () => {
        selectLanguage(filterButton.dataset.breaksLanguageFilter);
      });
    });

    shortcuts.forEach((shortcut) => {
      shortcut.addEventListener('click', () => {
        const target = filters.find((button) => button.dataset.breaksFilter === shortcut.dataset.breaksShortcut);
        if (!target) return;
        selectTcg(target.dataset.breaksFilter);
        catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const query = new URLSearchParams(window.location.search);
    selectTcg(query.get('tcg') || 'all');
    selectLanguage(query.get('language') || 'all');
  });

  document.querySelectorAll('[data-entry-popup]').forEach((popup) => {
    const dialog = popup.querySelector('[data-entry-popup-dialog]');
    const closeButtons = [...popup.querySelectorAll('[data-entry-popup-close]')];
    const copyButton = popup.querySelector('[data-popup-copy]');
    const campaignId = popup.dataset.campaignId || 'default';
    const frequency = popup.dataset.frequency || 'days';
    const rememberDays = Math.max(1, Number(popup.dataset.rememberDays || 7));
    const delay = Math.max(0, Number(popup.dataset.delay || 0)) * 1000;
    const expiresAt = Date.parse(popup.dataset.expiresAt || '');
    const storageKey = `iberian-entry-popup:${campaignId}`;
    const sessionKey = `${storageKey}:session`;
    const designMode = Boolean(window.Shopify?.designMode);
    let lastFocusedElement = null;

    const readStorage = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch {
        return null;
      }
    };

    const writeStorage = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch {
        return;
      }
    };

    const rememberDismissal = () => {
      if (frequency === 'session') {
        writeStorage(window.sessionStorage, sessionKey, '1');
      } else if (frequency === 'days') {
        writeStorage(window.localStorage, storageKey, String(Date.now()));
      }
    };

    const shouldOpen = () => {
      if (designMode) return true;
      if (Number.isFinite(expiresAt) && Date.now() > expiresAt) return false;
      if (frequency === 'every') return true;
      if (frequency === 'session') return !readStorage(window.sessionStorage, sessionKey);
      const lastSeen = Number(readStorage(window.localStorage, storageKey) || 0);
      return !lastSeen || Date.now() - lastSeen >= rememberDays * 86400000;
    };

    const openPopup = () => {
      if (!popup.hidden) return;
      lastFocusedElement = document.activeElement;
      popup.hidden = false;
      body.classList.add('entry-popup-open');
      dialog?.focus();
    };

    const closePopup = () => {
      if (popup.hidden) return;
      rememberDismissal();
      popup.hidden = true;
      body.classList.remove('entry-popup-open');
      lastFocusedElement?.focus?.();
    };

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    popup.querySelector('.entry-popup__actions a')?.addEventListener('click', rememberDismissal);

    copyButton?.addEventListener('click', async () => {
      const label = copyButton.querySelector('[data-popup-copy-label]');
      try {
        await navigator.clipboard.writeText(copyButton.dataset.code || '');
        if (label) label.textContent = 'CÓDIGO COPIADO ✓';
      } catch {
        if (label) label.textContent = copyButton.dataset.code || '';
      }
    });

    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePopup();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.detail?.sectionId === popup.dataset.sectionId) openPopup();
    });

    if (shouldOpen()) window.setTimeout(openPopup, designMode ? 0 : delay);
  });

  document.querySelectorAll('[data-countdown-date]').forEach((countdown) => {
    const value = countdown.dataset.countdownDate;
    if (!value) return;
    const target = new Date(value).getTime();
    if (Number.isNaN(target)) return;
    const update = () => {
      const distance = Math.max(0, target - Date.now());
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      const set = (key, number) => {
        const node = countdown.querySelector(`[data-${key}]`);
        if (node) node.textContent = String(number).padStart(2, '0');
      };
      set('days', days);
      set('hours', hours);
      set('minutes', minutes);
      set('seconds', seconds);
    };
    update();
    window.setInterval(update, 1000);
  });
})();
